module.exports = __webpack_public_path__ + "static/media/eRides-banner.0342c832.jpg";